import React from 'react';

export default function SectionEmpty({ show, title, subtitle, fullscreen = true }) {
    return (
        <>
            {
                show && (
                    <div  className={`${fullscreen ? 'h-screen' : ''} bg-white`}>
                        <div className="font-sans flex flex-col items-center justify-center px-4 py-20">
                            {
                                title && (
                                    <div className='text-xl font-bold'>
                                        <h1>{ title }</h1>
                                    </div>
                                )
                            }
                            {
                                subtitle && (
                                    <div className='text-sm text-center text-gray-500 leading-tight mt-4'>
                                        <h2>{ subtitle }</h2>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                )
            }
        </>        
    );
}